import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import DoorOpeningDirectionComponent from '../components/DoorOpeningDirectionComponent';
import { PlannerValidation } from './PlannerValidation';
export class DoorOpeningDirectionValidation extends PlannerValidation {
    constructor(coreApi, range) {
        super(coreApi, 'DoorOpeningDirectionValidation');
        this.range = range;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID)) {
            return this.validationOK();
        }
        const parent = this.range === 'besta'
            ? HierarchyUtils.parent(snapActionCandidate.host)
            : snapActionCandidate?.host;
        if (!parent) {
            return this.validationOK();
        }
        if (!parent.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            return this.validationOK();
        }
        const openingDirectionData = parent.getComponent(DoorOpeningDirectionComponent.id);
        if (!openingDirectionData) {
            return this.validationOK();
        }
        // If PAX door is narrower than the frame we allow the door to sit on either side
        if (this.isSmallerThanFrame(entity, parent) && this.range === 'pax') {
            return this.validationOK();
        }
        const connectionToFrame = snapActionCandidate.hostConnector;
        if (openingDirectionData.doorFrameConnectorKeys.length === 0) {
            openingDirectionData.doorFrameConnectorKeys.push(connectionToFrame.key);
            return this.validationOK();
        }
        // If BESTÅ door is narrower than the frame, check position in connector key before validation
        if (this.isSmallerThanFrame(entity, parent) && this.range === 'besta') {
            const keyFromList = openingDirectionData.doorFrameConnectorKeys.find(key => this.checkBestaConnectionPos(key, connectionToFrame.key));
            if (!keyFromList) {
                openingDirectionData.doorFrameConnectorKeys.push(connectionToFrame.key);
                return this.validationOK();
            }
            if (this.checkBestaConnection(keyFromList, connectionToFrame.key)) {
                return this.validationOK();
            }
            else {
                return this.validationFail(`Failed to validate doorOpeningDirection when checking bestå connection with key: ${keyFromList} frameConnection: ${connectionToFrame.key}`);
            }
        }
        if (openingDirectionData.doorFrameConnectorKeys.includes(connectionToFrame.key)) {
            return this.validationOK();
        }
        else {
            return this.validationFail(`Failed to validate doorOpeningDirection when getting doorFrameConnectorKeys. It does not contain key: ${connectionToFrame.key}`);
        }
    }
    isSmallerThanFrame(doorEntity, frameEntity) {
        const doorSize = doorEntity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
        const frameSize = frameEntity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
        return doorSize && frameSize ? doorSize.width < frameSize.width : false;
    }
    // Key string for wider bestå frames are constructed like this 'left-series-1-4'
    // where '1' is door postion on frame
    checkBestaConnectionPos(key1, key2) {
        const key1Parts = key1.split('-');
        const key1Pos = key1Parts[key1Parts.length - 2];
        const key2Parts = key2.split('-');
        const key2Pos = key2Parts[key2Parts.length - 2];
        return key1Pos === key2Pos;
    }
    // Check keys with last 2 chars removed for wider bestå frames
    checkBestaConnection(key1, key2) {
        const adjustedKey1 = key1.substring(0, key1.length - 2);
        const adjustedKey2 = key2.substring(0, key2.length - 2);
        return adjustedKey1 === adjustedKey2;
    }
}
//# sourceMappingURL=DoorOpeningDirectionValidation.js.map